export const API_URL = 'https://glq-movies-project-server.onrender.com/graphql';
// 'http://localhost:4000/graphql';
export const MAX_SELECTED_MOVIES = 20;
export const SOCIAL_BUTTON_SIZE = 32;
export const CONFIRM_TIMEOUT = 2000;
export const LOCALES = {
  ENGLISH: 'en-US',
  UKRAINIAN: 'uk-UA',
};
export const STORAGE_KEY = 'locale';

export const SORT_OPTIONS = [
  { label: 'popularity', value: 'popularity' },
  { label: 'release_date', value: 'release_date' },
  { label: 'revenue', value: 'revenue' },
  { label: 'primary_release_date', value: 'primary_release_date' },
  { label: 'original_title', value: 'original_title' },
  { label: 'vote_average', value: 'vote_average' },
  { label: 'vote_count', value: 'vote_count' },
];

export const SORT_DIRECTION = {
  DESC: 'desc',
  ASC: 'asc',
};
